import { withInstall } from '@lit-element/utils'
import TreeV2 from './src/tree.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtTreeV2: SFCWithInstall<typeof TreeV2> = withInstall(TreeV2)
export default LtTreeV2
